import React from "react";

import ModalAddUserProjectUsersMeetingRow from "./project-users-meeting-row";

export default function ModalAddUserProjectUsersMeeting(props) {
    if (!props.projectUsers) return false;

    const onRoleSelect = (userId, role) => {props.onRoleSelect(userId, role);}
    const onUserClick = (userId, e) => {props.onUserClick(userId, 'project', e);}

    return (
        <div className="ui5-manage-list users-with-access multiselect">
            {props.projectUsers.map((pu, key)=>
                <ModalAddUserProjectUsersMeetingRow key={key}
                                                    user={pu.user}
                                                    selected={props.selected}
                                                    onUserClick={onUserClick}
                                                    onRoleSelect={onRoleSelect}/>)}
        </div>
    )
}